module.exports = "/assets/data/87c6c34022432d1239caa88187b71140-CB1.data.json";